export const RESET_PASSWORD_PENDING = 'RESET_PASSWORD_PENDING';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const RESET_PASSWORD_ERROR_CLEAR = 'RESET_PASSWORD_ERROR_CLEAR';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
